import script from "./account-manage-edit.vue?vue&type=script&setup=true&lang=js"
export * from "./account-manage-edit.vue?vue&type=script&setup=true&lang=js"

import "./account-manage-edit.vue?vue&type=style&index=0&id=523d5f8a&lang=scss&scoped=true"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-523d5f8a"]])

export default __exports__